/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class InfluenceCass extends Logic
{
  constructor (influence)
  {
    super(influence);

    this.settings = influence.getBoard().getSettings();
  }


  updateValue (value, now)
  {
    this.object.set({ value });

    this.resetDuration(now);
  }


  resetDuration (now)
  {
    this.object.set({ createDate: now, destroyDate: now + this.settings.getDuration(this.cass.value) });
  }


  establish ()
  {
    this.object.set({ established: true });
  }


  isExpired (now)
  {
    return this.cass.destroyDate <= now;
  }


  canReset (now)
  {
    return this.getElapsedDuration(now) >= this.getTotalDuration() * this.settings.getInfluenceResetRatio();
  }


  getTotalDuration ()
  {
    return this.cass.destroyDate - this.cass.createDate;
  }


  getElapsedDuration (now)
  {
    return now - this.cass.createDate;
  }


};
